import { z } from 'zod';

import { preferredLanguageSchema } from './language';
import { alertChannelsSchema, projectUserRoleSchema } from './projectUser';
export const userProjectSchema = z.object({
  userProjectId: z.number(),
  userId: z.number(),
  projectId: z.number(),
  projectName: z.string().nullable(),
  role: projectUserRoleSchema,
});

export type User = z.infer<typeof userSchema>;
export const userSchema = z.object({
  userId: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  phoneNr: z.string(),
  companyId: z.number().nullable().optional(),
  personalConsumer: z.boolean().optional(),
  companyName: z.string(),
  isSiAdmin: z.boolean(),
  isSiOverlord: z.boolean().optional(),
  isDistributorUser: z.boolean().nullable().optional(),
  preferredLanguage: preferredLanguageSchema,
  projects: z.array(userProjectSchema),
  alertChannels: alertChannelsSchema.nullable().optional(),
  profilePictureUrl: z.string().nullable().optional(),
});

export type UpdateUserBody = z.infer<typeof updateUserBodySchema>;
export const updateUserBodySchema = z.object({
  personalConsumer: z.boolean().optional(),
  companyName: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phoneNr: z.string().optional(),
  companyId: z.number().nullable().optional(),
  preferredLanguage: preferredLanguageSchema.optional(),
});

export type NewUser = z.infer<typeof newUserSchema>;
export const newUserSchema = z.object({
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  phoneNr: z.string(),
  companyId: z.number().optional(),
  personalConsumer: z.boolean().optional(),
  companyName: z.string(),
});
